import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from '@hig/theme-context';
import { css, cx } from 'emotion';

var sizes = Object.freeze({
  xxs: "extraExtraSmall",
  xs: "extraSmall",
  s: "small",
  m: "medium",
  l: "large",
  xl: "extraLarge",
  xxl: "extraExtraLarge"
});

var AVAILABLE_SIZES = Object.freeze(Object.keys(sizes));

function stylesheet(props, themeData) {
  var size = props.size,
      spacing = props.spacing,
      customStylsheet = props.stylesheet;

  var styles = {
    spacer: {
      width: size || themeData["density.spacings." + sizes[spacing]],
      height: size || themeData["density.spacings." + sizes[spacing]],
      flex: size ? "0 0 " + size : "0 0 " + themeData["density.spacings." + sizes[spacing]]
    }
  };

  return customStylsheet ? customStylsheet(styles, props, themeData) : styles;
}

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Spacer = function (_Component) {
  _inherits(Spacer, _Component);

  function Spacer() {
    _classCallCheck(this, Spacer);

    return _possibleConstructorReturn(this, (Spacer.__proto__ || Object.getPrototypeOf(Spacer)).apply(this, arguments));
  }

  _createClass(Spacer, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          size = _props.size,
          spacing = _props.spacing,
          customStylesheet = _props.stylesheet,
          otherProps = _objectWithoutProperties(_props, ["size", "spacing", "stylesheet"]);

      var className = otherProps.className;

      return React.createElement(
        ThemeContext.Consumer,
        null,
        function (_ref) {
          var resolvedRoles = _ref.resolvedRoles;

          var styles = stylesheet({ size: size, spacing: spacing, stylesheet: customStylesheet }, resolvedRoles);
          return React.createElement("div", { className: cx([className, css(styles.spacer)]) });
        }
      );
    }
  }]);

  return Spacer;
}(Component);

Spacer.propTypes = {
  /** Used for passing custom values to the spacer, in lieu of a fixed amount */
  size: PropTypes.string,
  /** Sets the size of the spacer */
  spacing: PropTypes.oneOf(AVAILABLE_SIZES),
  /** Adds custom/overriding styles */
  stylesheet: PropTypes.func
};
Spacer.defaultProps = {
  spacing: "m"
};
Spacer.__docgenInfo = {
  "description": "",
  "displayName": "Spacer",
  "props": {
    "size": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Used for passing custom values to the spacer, in lieu of a fixed amount"
    },
    "spacing": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "AVAILABLE_SIZES"
      },
      "required": false,
      "description": "Sets the size of the spacer",
      "defaultValue": {
        "value": "\"m\"",
        "computed": false
      }
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Adds custom/overriding styles"
    }
  }
};

export default Spacer;
